import React, {useState, useMemo, useEffect, useRef} from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import CSS from 'csstype'
const BackDrop = (props: any) => {
  const spinner: CSS.Properties = {
    width: '3rem',
    height: '3rem',
  }

  return (
    <Modal
      show={props.showBackDrop}
      backdrop='static'
      keyboard={false}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='timeSheetBackDrop'
    >
      {/* <div className='spinner-border text-primary' style={spinner} role='status'>
        {props.showBackDrop && props.ShowNS && <span role='status'>Loading...</span>}
      </div> */}

      <div className='d-flex flex-column align-items-center'>
        {/* Spinner */}
        <div className='spinner-border text-primary' style={spinner} role='status'></div>
        {/* Static Loading Text */}
        {/* Please wait while we are exporting invoices data .... */}
        {props.showBackDrop && props.ShowNS && (
          <span
            role='status'
            className='mt-3 font-weight-bold'
            style={{
              fontSize: '1.5rem',
              color: '#ffffff', // Text color set to white for better contrast
              backgroundColor: '#4B6A92', // Background color behind text
              padding: '10px 15px', // Adds padding to create space around the text
              borderRadius: '5px', // Rounds the corners of the background
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow for better contrast
            }}
          >
            Please wait while we are sending invoice and attachment to Netsuite ...
          </span>
        )}
        {props.showBackDrop && props.exportNS && (
          <span
            role='status'
            className='mt-3 font-weight-bold'
            style={{
              fontSize: '1.5rem',
              color: '#ffffff', // Text color set to white for better contrast
              backgroundColor: '#4B6A92', // Background color behind text
              padding: '10px 15px', // Adds padding to create space around the text
              borderRadius: '5px', // Rounds the corners of the background
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow for better contrast
            }}
          >
            Please wait while we are exporting invoices data ...
          </span>
        )}
        {props.showBackDrop && props.pdfLoader && (
          <span
            role='status'
            className='mt-3 font-weight-bold'
            style={{
              fontSize: '1.5rem',
              color: '#ffffff', // Text color set to white for better contrast
              backgroundColor: '#4B6A92', // Background color behind text
              padding: '10px 15px', // Adds padding to create space around the text
              borderRadius: '5px', // Rounds the corners of the background
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow for better contrast
            }}
          >
            Please wait while we are converting to pdf ...
          </span>
        )}

        {props.showBackDrop && props.viewpdfLoader && (
          <span
            role='status'
            className='mt-3 font-weight-bold'
            style={{
              fontSize: '1.5rem',
              color: '#ffffff', // Text color set to white for better contrast
              backgroundColor: '#4B6A92', // Background color behind text
              padding: '10px 15px', // Adds padding to create space around the text
              borderRadius: '5px', // Rounds the corners of the background
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow for better contrast
            }}
          >
            Please wait while loading the attachment ...
          </span>
        )}
        {props.showBackDrop && props.ShowTSNS && (
          <span
            role='status'
            className='mt-3 font-weight-bold'
            style={{
              fontSize: '1.5rem',
              color: '#ffffff', // Text color set to white for better contrast
              backgroundColor: '#4B6A92', // Background color behind text
              padding: '10px 15px', // Adds padding to create space around the text
              borderRadius: '5px', // Rounds the corners of the background
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow for better contrast
            }}
          >
            Timesheet Approved Successfully. Please wait as Timesheets are sending to NetSuite ...
          </span>
        )}
      </div>
    </Modal>
  )
}
export default BackDrop
